<template>
  <aside class="w-96 bg-white border-l border-gray-200 flex flex-col">
    <!-- Chat Header -->
    <div class="p-4 border-b border-gray-200 flex items-center justify-between">
      <div class="flex items-center gap-2">
        <UIcon name="i-lucide-message-circle" class="size-5 text-gray-700" />
        <h2 class="font-semibold text-gray-900">Chat Assistant</h2>
      </div>
      <UButton 
        icon="i-lucide-x"
        color="gray"
        variant="ghost"
        size="sm"
        @click="$emit('close')"
      />
    </div>

    <!-- Messages Area -->
    <ChatMessages :messages="messages" :is-typing="isTyping" />

    <!-- Chat Input -->
    <ChatInput 
      :messages="messages" 
      v-model:isTyping="isTyping" 
      @upload-file="handleFileUpload"
      :focus-input="focusInput"
      @input-focused="$emit('input-focused')"
    />

  </aside>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useProjectsStore } from '~/stores/projects'
import { useAuthStore } from '~/stores/auth'
import { useAppStore } from '~/stores/app'

const props = defineProps({
  focusInput: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close', 'upload-file', 'input-focused'])

const projectsStore = useProjectsStore()
const authStore = useAuthStore()
const appStore = useAppStore()

const { selectedProject } = storeToRefs(projectsStore)
const { currentUser } = storeToRefs(authStore)
const { isTyping } = storeToRefs(appStore)

const messages = computed(() => {
  if (selectedProject.value && currentUser.value) {
    return projectsStore.getChatMessages(selectedProject.value.id, currentUser.value.id)
  }
  return []
})

const handleFileUpload = (files) => {
  emit('upload-file', files)
}
</script>